import { TimePeriod } from '@hakimo-ui/hakimo/types';
import { AlarmGroupFilterValues } from '../types';

export function isNotDefaultFilter(
  filters: Partial<AlarmGroupFilterValues>,
  timePeriod?: TimePeriod
): boolean {
  return (
    (filters.status && filters.status.values.length > 0) ||
    (filters.priority && filters.priority.values.length > 0) ||
    (filters.location && filters.location.values.length > 0) ||
    (filters.camera && filters.camera.values.length > 0) ||
    filters.escalated === true ||
    (timePeriod && timePeriod !== TimePeriod.PAST_24_HOURS) ||
    false
  );
}
